import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { type PropsWithChildren } from 'react';
import { Platform } from 'react-native';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 3,
            retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
            staleTime: 5 * 60 * 1000, // 5 minutes
            // Avoid idle/focus refetch spam on web; keep native focus refetch.
            refetchOnWindowFocus: Platform.OS !== 'web',
        },
    },
});

export function QueryProvider({ children }: Readonly<PropsWithChildren>) {
    return (
        <QueryClientProvider client={queryClient}>
            {children}
        </QueryClientProvider>
    );
}
